// extracted by mini-css-extract-plugin
module.exports = {"facePileMore":"ValueFacePile_facePileMore__39jgK","wrapper":"ValueFacePile_wrapper__2Tp-o"};